import { ref, computed } from 'vue'

export interface StateMapStats {
  min_salary: number
  max_salary: number
  avg_salary: number
}
export interface StateSalary {
  state: string
  state_full: string
  median_salary: number
}
export default function useStateSalaryData(
  permalink: string,
  role: Ref<string>,
  initialData: any = null
) {
  const stateData = ref<StateSalary[]>([])
  const mapStats = ref<StateMapStats>({
    min_salary: 0,
    max_salary: 0,
    avg_salary: 0
  })
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  const isInitialized = ref(false)
  if (initialData && initialData.success && initialData.data) {
    stateData.value = initialData.data.states || []
    mapStats.value = initialData.data.stats || {
      min_salary: 0,
      max_salary: 0,
      avg_salary: 0
    }
    if (
      mapStats.value.min_salary === mapStats.value.max_salary
      && stateData.value.length > 1
    ) {
      const baseValue = mapStats.value.min_salary || 50000
      mapStats.value.min_salary = baseValue * 0.9
      mapStats.value.max_salary = baseValue * 1.1
    }
    isInitialized.value = true
  } else if (initialData?.error) {
    // Only set error for actual fetch failures, not for empty data
    error.value = initialData.error
  }
  // No data is not an error - the map will render with default gray states
  const queryKey = computed(
    () => `state-map-${permalink}-${role.value || 'all'}`
  )
  const mainStates = computed(() => {
    return stateData.value.filter(
      state => state.state !== 'AK' && state.state !== 'HI'
    )
  })
  const alaskaState = computed(() => {
    return stateData.value.find(state => state.state === 'AK')
  })
  const hawaiiState = computed(() => {
    return stateData.value.find(state => state.state === 'HI')
  })
  return {
    stateData,
    mapStats,
    isLoading,
    error,
    mainStates,
    alaskaState,
    hawaiiState,
    isInitialized,
    queryKey
  }
}
